// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1vf6Z","itemTitle":"ClientEmergencyInfo_itemTitle__3sUDn","itemText":"ClientEmergencyInfo_itemText__hHUlI"};